import * as Sentry from '@sentry/browser';

/**
 * Handler padrão para erros 401.
 * Apenas loga o erro e rejeita a promise — NÃO desloga nem recarrega a página,
 * pois um único componente/serviço com 401 não deve derrubar toda a sessão.
 * O logout real deve ser tratado somente na camada de autenticação (AuthService/login).
 */
export function error401Handler(error) {
  Sentry.captureException(error);
  console.warn('[401] Unauthorized request. The component will handle this gracefully.');
  return Promise.reject(error);
}
